import { Component } from '@angular/core';
import { MainNavConfig } from '../../main-navigation/main-navigation.component';

@Component({
  selector: 'app-top-bar-showcase',
  templateUrl: './top-bar-showcase.component.html',
  styleUrls: ['./top-bar-showcase.component.scss']
})
export class TopBarShowcaseComponent {
  navConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: '/showcase/tb-preview/challenges',     icon: 'trophy' },
      { label: 'Dashboard',      routerLink: '/showcase/top-bar',                   icon: 'dashboard' },
      { label: 'Manage Claims',  routerLink: '/showcase/tb-preview/claims',         icon: 'description' },
      { label: 'Redeem Rewards', routerLink: '/showcase/tb-preview/redeem-rewards', icon: 'card_giftcard' },
      { label: 'Leaderboards',   routerLink: '/showcase/tb-preview/leaderboards',   icon: 'leaderboard' },
    ]
  };
}
